export type EditorAccess = EditorReadAccess | EditorWriteAccess;

export enum EditorAccessModesEnum {
  READ = 'read',
  WRITE = 'write',
}

export interface EditorReadAccess {
  mode: EditorAccessModesEnum.READ;
}

export interface EditorWriteAccess {
  mode: EditorAccessModesEnum.WRITE;
}
